import { createActionLayout } from '@malesia/react-components/dist/src/components/Table/columns/actionsColumn/actionLayout';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export const editManager = createActionLayout({
    text: (
        <FormattedMessage
            id='front-app/ManagerListPage:editTitle'
            defaultMessage='Edit manager'
        />
    ),
    iconName: 'edit',
});
